import React from 'react';
import { useTranslation } from 'react-i18next';
import DestinyFooter from '@myriadgenetics/web-components/dist/react/footer';
import { Text3, H3 } from '../../elements/typography';
import FooterNav from './components/footerNav';
import SocialMenu from './components/socialMenu';
import alternativeLogo from '../../assets/myriad-logo.png';
import { publicUrl } from '../../helpers/url';
import { footerNav, footerMenuNav, socialMenu } from './constants';
import './index.scss';
import { FooterProps } from './types';

function Footer({ isAlternativeStyle, isChatbot, isDemo }: FooterProps) {
  const { t } = useTranslation();
  const links = [
    { text: t('footer.nav.contact'), url: 'https://myriad.com/contact-us' },
    { text: t('footer.nav.terms'), url: 'https://myriad.com/terms-of-use' },
    { text: t('footer.nav.privacy'), url: 'https://myriad.com/privacy-notice' },
    { text: t('footer.nav.privacyPractices'), url: 'https://myriad.com/notice-privacy-practices' },
    { text: t('footer.nav.nondiscrimination'), url: 'https://myriad.com/compliance/notice-statement-concerning-nondiscrimination-accessibility' },
    {
      text: t('footer.nav.auxiliary'),
      url: 'https://myriad.com/compliance/notice-of-availability-of-language-assistance-services-and-auxiliary-aids-and-services',
    },
  ];

  const footerClassName = React.useMemo(() => {
    if (isAlternativeStyle) {
      return 'alternative-style';
    }

    if (isChatbot) {
      return 'myra-footer';
    }
    return 'classic';
  }, [isAlternativeStyle, isChatbot]);

  return (
    <footer className={`footer ${footerClassName}`}>
      {!isAlternativeStyle ? (
        <DestinyFooter className={footerClassName || 'footer'} variant="patient" copyright=" " newTab links={links} />
      ) : (
        <>
          <div className="footer__menu-wrapper">
            <div className="footer__menu">
              <FooterNav items={footerMenuNav} />
              <SocialMenu items={socialMenu} />
            </div>
          </div>
          <div className="footer__top">
            <a href={publicUrl} className="footer__logo-link" title={t('logo.alt')}>
              <img alt={t('logo.alt')} src={alternativeLogo} className="footer__logo" />
            </a>
            <H3>{t('footer.text')}</H3>
          </div>
          <div className="footer__bottom">
            <FooterNav items={footerNav} isSimpleView />
            <Text3 className="footer__copyright">{t('footer.copyright')}</Text3>
          </div>
        </>
      )}
      {isDemo && !isAlternativeStyle && <div className="survey-container__demo-indicator">{t('demoIndicator')}</div>}
    </footer>
  );
}

export default Footer;
